import React, { Component } from 'react';
import BannerTitle from '../layouts/about/banner/BannerTitle'
import { FormContact02, IconBox } from '../layouts/contact';
import {TitleHeading} from '../layouts/home01/index'
import {Header, Footer, TopBar, BottomBar} from '../layouts/general/index'

class Contact02 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    logoweb: "assets/img/logo-small.png",
                    names: "Contact",
                }
            ],
            banners: [
                {
                    id: 1,
                    links: '',
                    titlelink: '',
                    border: '',
                    name: 'Contact',
                    heading: 'Contact Us'
                }
            ],
            headingcontact: [
                {
                    id: 1,
                    classnames: 'heading',
                    title: 'CONTACT US',
                    text: 'Are you interested in finding out how ASC Construction Services can make your project a success? For more information on our services please contact us.',
                    classtext: 'sub-heading font-weight-400 max-width-770 line-height-26 margin-top-14',
                }
            ],
            companyData: null,
            loading: true,
            error: null
        }
    }

    componentDidMount() {
        this.fetchCompanyData();
    }

    fetchCompanyData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const response = await fetch('https://asc-admin.vercel.app/api/company/68ebabc1c3db3fcb7ac32696');
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();
            
            if (result.success && result.data) {
                this.setState({
                    companyData: result.data,
                    loading: false
                });
            } else {
                throw new Error('Invalid data format from company API');
            }
            
        } catch (error) {
            console.error('Error fetching company data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    handleContactSubmit = async (contactData) => {
        try {
            const response = await fetch('/api/contacts', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactData),
            });

            const result = await response.json();

            if (response.ok && result.success) {
                // Show success message
                alert('Thank you for your message! We will get back to you soon.');
                return true;
            } else {
                alert(result.error || 'Failed to send message. Please try again.');
                return false;
            }
        } catch (error) {
            console.error('Error submitting contact form:', error);
            alert('Error sending message. Please try again.');
            return false;
        }
    }

    renderContactContent() {
        const { companyData, loading, error } = this.state;

        if (loading) {
            return (
                <div className="row-iconbox">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="themesflat-spacer clearfix" data-desktop={61} data-mobile={60} data-smobile={60} />
                                <div className="text-center">
                                    <div className="loading-spinner">Loading contact information...</div>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={58} data-mobile={35} data-smobile={35} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="row-iconbox">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="themesflat-spacer clearfix" data-desktop={61} data-mobile={60} data-smobile={60} />
                                <div className="text-center error-message">
                                    <h3>Error loading contact information</h3>
                                    <p>{error}</p>
                                    <button 
                                        onClick={this.fetchCompanyData} 
                                        className="themesflat-button bg-accent"
                                    >
                                        Retry
                                    </button>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={58} data-mobile={35} data-smobile={35} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="row-iconbox">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="themesflat-spacer clearfix" data-desktop={61} data-mobile={60} data-smobile={60} />
                            {
                                this.state.headingcontact.map(data => (
                                    <TitleHeading data={data} key={data.id}/>
                                ))
                            }
                            <div className="themesflat-spacer clearfix" data-desktop={45} data-mobile={35} data-smobile={35} />
                        </div>
                    </div>
                    
                    {/* Pass company data to IconBox component */}
                    <IconBox companyData={companyData} />
                    
                    <div className="row">
                        <div className="col-md-12">
                            <div className="themesflat-spacer clearfix" data-desktop={58} data-mobile={35} data-smobile={35} />
                        </div>
                    </div>
                    
                    {/* Pass company data and submit handler to FormContact02 */}
                    <FormContact02 
                    className="py-5"
                        companyData={companyData} 
                        onSubmit={this.handleContactSubmit}
                    />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="header-fixed page no-sidebar header-style-2 topbar-style-1 menu-has-search">
                <div id="wrapper" className="animsition">
                    <div id="page" className="clearfix">
                        <div id="site-header-wrap">
                            <TopBar />
                            {
                                this.state.headers.map((data,idx) =>(
                                    <Header data={data} key={idx}/>
                                ))
                            }
                        </div>
                        {
                            this.state.banners.map(data =>(
                                <BannerTitle key={data.id} data={data}/>
                            ))
                        }
                        <div id="main-content" className="site-main clearfix">
                            <div id="content-wrap">
                                <div id="site-content" className="site-content clearfix">
                                    <div id="inner-content" className="inner-content-wrap">
                                        <div className="page-content">
                                            {this.renderContactContent()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                    {
                        this.state.headers.map((data,idx) =>(
                            <BottomBar data={data} key={idx}/>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default Contact02;